import { StorageProtectionExclusionItem } from '@nirvana/shared/dtos/types/policies/common';
import { getLabelByExclusionItemType } from '../../../../utils/uiSettings/storageProtection/storage-protection.values';
import { compareStrings } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';
import { ColumnKeys } from '../gridComponents/grid-config';

// sort by column type
export function sortByColumn(
  item1: StorageProtectionExclusionItem,
  item2: StorageProtectionExclusionItem,
  columnName: string,
  direction: string
): number {
  switch (columnName) {
    case ColumnKeys.TYPE:
      return compareStrings(
        getLabelByExclusionItemType(item1.type),
        getLabelByExclusionItemType(item2.type),
        direction
      );

    case ColumnKeys.PATH:
      return compareStrings(item1.path, item2.path, direction);

    case ColumnKeys.DESCRIPTION:
      return compareStrings(item1.description, item2.description, direction);
  }

  return 0;
}
